import React from 'react';
import EditOrAddGroupContactModalContainer from 'containers/Modals/EditOrAddGroupContactModalContainer';

export const EditGroupContactModal: React.FunctionComponent = () => 
    <EditOrAddGroupContactModalContainer isEditingExisting={true} />;
